module.exports = __webpack_public_path__ + "static/img/TW.8a74c754.jpg";